import { initExploreProjects } from '../../../explore/projects/index.js?vue3';

initExploreProjects();
